var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Radio from 'syf-component-library/ui/atoms/Radio';
const RadioCardWrapper = styled.div `
  padding: ${({ theme: { spacing } }) => ` ${spacing.base}px 0`};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border-top: 1px solid ${({ theme }) => `${theme.colors.lightGrey}`};

  &:last-child {
    border-bottom: 1px solid ${({ theme }) => `${theme.colors.lightGrey}`};
  }
`;
const RadioContainer = styled.div `
  display: flex;
  align-items: center;
`;
const Label = styled.span `
  font-size: ${({ theme }) => theme.fontSizes.root}px;
  line-height: ${({ theme }) => theme.lineHeights.root};
  display: flex;
  align-items: center;
`;
const SubText = styled.p `
  margin-left: 35px;
  font-size: ${({ theme }) => theme.fontSizes.small}px;
  line-height: ${({ theme }) => theme.lineHeights.small};
`;
const RadioList = (_a) => {
    var { label, subText, radioProps, onClick } = _a, props = __rest(_a, ["label", "subText", "radioProps", "onClick"]);
    return (_jsxs(RadioCardWrapper, Object.assign({}, props, { "data-testid": "radio-list-wrapper", onClick: onClick }, { children: [_jsx(RadioContainer, { children: _jsx(Radio, Object.assign({}, radioProps, { children: _jsx(Label, { children: label }) })) }), _jsx(SubText, { children: subText })] })));
};
export default RadioList;
//# sourceMappingURL=index.js.map